
(function(){
  const grid=document.querySelector('[data-product-grid]');
  const availability=document.querySelector('[data-filter-availability]');
  const priceFilter=document.querySelector('[data-filter-price]');
  const sorter=document.querySelector('[data-sort-products]');
  const count=document.querySelector('[data-product-count]');
  const empty=document.querySelector('[data-collection-empty]');
  function refreshCollection(){
    if(!grid) return;
    const cards=[...grid.querySelectorAll('.product-card')];
    const availabilityValue=availability?.value||'all';
    const priceValue=priceFilter?.value||'all';
    const sortValue=sorter?.value||'featured';
    const sorted=[...cards].sort((a,b)=>{
      if(sortValue==='best-selling') return Number(b.dataset.salesRank||0)-Number(a.dataset.salesRank||0);
      if(sortValue==='alpha-asc') return a.dataset.productName.localeCompare(b.dataset.productName);
      if(sortValue==='alpha-desc') return b.dataset.productName.localeCompare(a.dataset.productName);
      if(sortValue==='price-asc') return Number(a.dataset.priceValue)-Number(b.dataset.priceValue);
      if(sortValue==='price-desc') return Number(b.dataset.priceValue)-Number(a.dataset.priceValue);
      return Number(a.dataset.featuredIndex)-Number(b.dataset.featuredIndex);
    });
    sorted.forEach(card=>grid.appendChild(card));
    let visible=0;
    cards.forEach(card=>{
      const price=Number(card.dataset.priceValue);
      const availabilityMatch=availabilityValue==='all'||(availabilityValue==='available'&&card.dataset.available==='true')||(availabilityValue==='unavailable'&&card.dataset.available!=='true');
      const priceMatch=priceValue==='all'||(priceValue==='under-1000'&&price<1000)||(priceValue==='1000-1999'&&price>=1000&&price<2000)||(priceValue==='2000-plus'&&price>=2000);
      card.hidden=!(availabilityMatch&&priceMatch);
      if(!card.hidden) visible+=1;
    });
    if(count) count.textContent=`${visible} ${visible===1?'item':'items'}`;
    if(empty) empty.hidden=visible!==0;
  }
  availability?.addEventListener('change',refreshCollection);
  priceFilter?.addEventListener('change',refreshCollection);
  sorter?.addEventListener('change',refreshCollection);
  document.querySelectorAll('[data-grid-view]').forEach(button=>button.addEventListener('click',()=>{
    const compact=button.dataset.gridView==='compact';
    grid?.classList.toggle('is-compact',compact);
    document.querySelectorAll('[data-grid-view]').forEach(item=>{
      const active=item===button;
      item.classList.toggle('active',active);
      item.setAttribute('aria-pressed',String(active));
    });
  }));
  refreshCollection();
})();
